import { computed, defineComponent, ref } from 'vue';
import { ComponentSize } from '@/models/common/component-size.model';
import { usePaymentStore } from '@/store/paymont/payment.store';
import { storeToRefs } from 'pinia';
import { Lock } from '@element-plus/icons-vue';
import { PayoutOrderEvents } from '@/models/payout-order/payout-order-events.model';

export default defineComponent({
  name: 'PayoutOrderManualDialog',
  components: {
    Lock,
  },
  emits: [PayoutOrderEvents.CLOSE_DIALOG],
  setup(_props, { emit }) {
    const moderationComment = ref<string>('');

    const paymentStore = usePaymentStore();
    const { currentPayoutOrder, isManualDialogVisible } = storeToRefs(paymentStore);
    const {
      updateProcessingModeratedTransactionManualFlow,
      setManualDialogVisible,
    } = paymentStore;

    const isModerationCommentEmpty = computed<boolean>(() => moderationComment.value.length === 0);

    const takeManualFlowTransaction = async (): Promise<void> => {
      if (!currentPayoutOrder.value) {
        return;
      }

      const { playerId, whitelabelSlug, bpWlTransactionId } = currentPayoutOrder.value;
      await updateProcessingModeratedTransactionManualFlow({
        playerId,
        whitelabelSlug,
        bpWlTransactionId,
        comment: moderationComment.value,
      });

      closeDialog();
      emit(PayoutOrderEvents.CLOSE_DIALOG);
    };

    const closeDialog = (): void => {
      setManualDialogVisible(false);
      moderationComment.value = '';
    };

    return {
      ComponentSize,
      takeManualFlowTransaction,
      moderationComment,
      isModerationCommentEmpty,
      isManualDialogVisible,
      closeDialog,
    };
  },
});
